import React, { useState, useEffect } from "react";
import { Navbar } from "../components/Navbar";
import { PostCard } from "../components/PostCard";
import "../assets/HomePage.css"
import { GetFriendsPosts } from "../services/postService";
import { jwtDecode } from "jwt-decode";
import { CustomJwtPayload } from "../components/ProtectRoutes";
import { Post } from "../models/postModel";
import { CreatePost } from "../components/CreatePost";
import { HomeLeftSide } from "../components/HomeLeftSide";
import { HomeRightSide } from "../components/HomeRightSide";


export const HomePage: React.FC = () => {
    const [posts,setPosts]= useState<Post[]>([]);
    const [isLoading, setIsLoading] = useState(false);

    const loadPosts = async (user_id: string) => {
      if (isLoading) return;
      setIsLoading(true);
  
      try {
          const posts = await GetFriendsPosts(user_id);
          setPosts(posts);
      } catch (error) {
          console.error("Error loading posts:", error);
      } finally {
          setIsLoading(false);
      }
  };

    useEffect(() => {
      const token = localStorage.getItem('token'); 
      if (token) {
          const decodedToken = jwtDecode<CustomJwtPayload>(token); 
          loadPosts(decodedToken.sub);
      }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); 
  
  




  return (<>
    <div className="home-page">
      <Navbar />
      <div className="home-layout" >

      <div className="left-side" >
        <HomeLeftSide />
      </div>


        <div className="main-content">
          <CreatePost />
          {posts.length > 0 ? (
            posts.map((post) => (
              <PostCard key={post._id} post={post} />
            ))
          ) : (
            <div style={{textAlign: "center", marginTop: "var(--spacing-3xl)", padding: "var(--spacing-2xl)"}}>
              <h2 style={{color: "var(--color-text-secondary)", fontSize: "1.5rem", fontWeight: 600}}>Find New Friends</h2>
              <p style={{color: "var(--color-text-muted)", marginTop: "var(--spacing-md)"}}>Start connecting with people in your community</p>
            </div>
          )}
        </div>

        <div className="right-side">
          <HomeRightSide />
        </div>
      </div>
    </div>
    </>
  );
};
